import {
    CREATE_PROCESS_PAYROLL,
    DELETE_PAYROLL,
    GET_ACTIVE_PAYROLL,
    GET_ACTIVE_PROCESS_PAYROLL,
    GET_PAYROLL_BY_ID,
    GET_PROCESSED_PAYROLL,
    GET_PROCESSED_PAYROLL_BATCHES,
    RESOLVE_PAYROLL,
    UN_PROCESS_PAYROLL,
} from './staffPayroll.types';

/** Active Payroll */

export const getActivePayroll = (params, load) => {
    return {
        type: GET_ACTIVE_PAYROLL,
        payload: { params, load },
    };
};
export const getActiveProcessPayroll = (params) => {
    return {
        type: GET_ACTIVE_PROCESS_PAYROLL,
        payload: { params },
    };
};

export const createProcessPayroll = (ids, params) => {
    return {
        type: CREATE_PROCESS_PAYROLL,
        payload: { ids, params },
    };
};
export const getPayrollById = (id) => {
    return {
        type: GET_PAYROLL_BY_ID,
        payload: { id },
    };
};
export const deletePayroll = (id) => {
    return {
        type: DELETE_PAYROLL,
        payload: { id },
    };
};

export const resolvePayroll = (id, params) => {
    return {
        type: RESOLVE_PAYROLL,
        payload: { id, params },
    };
};

/** End */

/** Processed Payroll */

export const getProcessedPayroll = (params, load) => {
    return {
        type: GET_PROCESSED_PAYROLL,
        payload: { params, load },
    };
};

export const getProcessedPayrollBatches = (params, id, load) => {
    return {
        type: GET_PROCESSED_PAYROLL_BATCHES,
        payload: { params, id, load },
    };
};

export const unProcessPayroll = (ids) => {
    return {
        type: UN_PROCESS_PAYROLL,
        payload: { ids },
    };
};

/** End */

/** End */
